import { AuthorizationCredentialsServiceFactory } from 'frontcore/domain/authorization/factory'
import { ref } from 'vue'

class UseCredentialsLogin {

  readonly #applicationId?: string

  constructor (applicationId?: string) {
    this.#applicationId = applicationId
  }

  use () {
    const loginService = AuthorizationCredentialsServiceFactory.build()
    const error = ref<string | null>(null)
    const login = async (username: string, password: string): Promise<void> => {
      try {
        await loginService.login(username, password, this.#applicationId)
        error.value = null
      } catch (e) {
        if (e instanceof Error) {
          error.value = e.message
          return
        }
        throw e
      }
    }
    return {
      error,
      login,
    }
  }

}

export default UseCredentialsLogin
